import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function HeaderSticky() {
    const { t } = useLang('powerstream.detail');

    return (
        <div className={styles.headerSticky}>
            <div className="header-box">
                <p className="header-text">{t('firstKv.headerText')}</p>
            </div>
        </div>
    );
}
